import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
// import { IdentityProvider } from './context/IdentityContext';
import './styles/variables.css';
import './styles/index.css';
import 'primeflex/primeflex.css';
import { Provider } from 'react-redux';
import { ThemeProvider } from './context/ThemeContext';
import { store } from './store/store';
import { AuthProvider } from './context/AuthContext';
import { TimezoneProvider } from './context/TimezoneContext';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  // <React.StrictMode>
  <BrowserRouter>
    {/* <IdentityProvider> */}
    <Provider store={store}>
      <TimezoneProvider>
        <AuthProvider>
          <QueryClientProvider client={queryClient}>
            <ThemeProvider>
              <div id="app-content">
                <App />
              </div>
            </ThemeProvider>
          </QueryClientProvider>
        </AuthProvider>
      </TimezoneProvider>
    </Provider>
    {/* </IdentityProvider> */}
  </BrowserRouter>
  // </React.StrictMode>
);